import { Stack } from "@mui/material";
import { DesignerFileType } from "../../../../__generated__/types";
import { H6Typography } from "../../../../components/typography";
import { DesignerFileTypeLabels } from "../../../../utils";
import { TypeButton } from "../../../../components/type-button";
import { ProjectProfileIcon, BeforeAfterIcon, DesignBoardsIcon } from "../../../../components/designer-file-icons";

const icons = {
  [DesignerFileType.ProjectProfile]: ProjectProfileIcon,
  [DesignerFileType.BeforeAndAfter]: BeforeAfterIcon,
  [DesignerFileType.DesignBoard]: DesignBoardsIcon,
};

export const DesignerFileTypeButton = ({
  onSelect,
  type,
}: {
  onSelect: (type: DesignerFileType) => void;
  type: DesignerFileType;
}) => {
  const Icon = icons[type];

  return (
    <TypeButton
      sx={{
        width: "336px",
        borderColor: "#a8a8a8",
        borderWidth: "1px",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          borderColor: "#00A06D",
          borderWidth: "2px",
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(0, 160, 109, 0.15)",
        },
      }}
      icon={
        <Icon 
          width={40} 
          height={40} 
          color="#D22268"
        />
      }
      onClick={() => onSelect(type)}
    >
      <H6Typography component="p" mt="16px">
        {DesignerFileTypeLabels[type]}
      </H6Typography>
    </TypeButton>
  );
};

export const DesignerFileTypeSelection = ({
  onSelect,
}: {
  onSelect: (type: DesignerFileType) => void;
}) => {
  return (
    <Stack
      spacing={5}
      sx={{ width: "100%" }}
      direction={{
        xs: "column",
        md: "row",
      }}
      justifyContent={"space-around"}
      alignItems="center"
    >
      <DesignerFileTypeButton
        onSelect={onSelect}
        type={DesignerFileType.ProjectProfile}
      />
      <DesignerFileTypeButton
        onSelect={onSelect}
        type={DesignerFileType.BeforeAndAfter}
      />
      <DesignerFileTypeButton
        onSelect={onSelect}
        type={DesignerFileType.DesignBoard}
      />
    </Stack>
  );
};
